import { render, staticRenderFns } from "./VolunteerAddManualTime.vue?vue&type=template&id=36823c53&scoped=true"
import script from "./VolunteerAddManualTime.vue?vue&type=script&lang=js"
export * from "./VolunteerAddManualTime.vue?vue&type=script&lang=js"
import style0 from "./VolunteerAddManualTime.vue?vue&type=style&index=0&id=36823c53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36823c53",
  null
  
)

export default component.exports